import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { DefaultRadio, DefaultRangePicker, NumberInput, PasswordBox, TextInput, styleVariables } from '@lib/common';
import { Col, Form, InputNumber, Radio, Select, Skeleton, Switch } from 'antd';
import styled, { css } from 'styled-components';
import { Duration, ScoreVisibilityType, UnixTimestamp } from '@module/assignment';
import { getPastTime } from '../../utils';
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var verticalStyle = css([".ant-row{display:flex;flex-flow:row;align-items:center;.ant-col{max-width:50%;&:last-child{margin-left:10px;}}}.ant-form-item-label{padding:0px;text-align:center;}.ant-switch-checked{background-color:", ";}"], styleVariables.colors.blue6);
export var StyledRequiredMark = styled.span.withConfig({
  displayName: "base-optionscomponent__StyledRequiredMark",
  componentId: "sc-nlcd1i-0"
})(["color:", ";margin-left:4px;"], styleVariables.colors.red4);
export var StyledInputNumber = styled(InputNumber).withConfig({
  displayName: "base-optionscomponent__StyledInputNumber",
  componentId: "sc-nlcd1i-1"
})(["border-radius:8px;width:100%;"]);
var StyledTimestampSelectionColumn = styled(Col).withConfig({
  displayName: "base-optionscomponent__StyledTimestampSelectionColumn",
  componentId: "sc-nlcd1i-2"
})([".ant-form-item{margin-bottom:0px;}.ant-form-item .ant-form-item-row{margin-bottom:0px;}"]);
export var InlineOption = styled(Form.Item).withConfig({
  displayName: "base-optionscomponent__InlineOption",
  componentId: "sc-nlcd1i-3"
})(["", " ", " ", ""], verticalStyle, function (props) {
  return props.isDropDown && "\n      margin-bottom: 0px;\n      margin-top: 24px;\n    ";
}, function (props) {
  return props.isSelectOnly && "\n      margin-bottom: 24px;\n      margin-top: 24px;\n    ";
});
var ExpectationInput = styled(NumberInput).withConfig({
  displayName: "base-optionscomponent__ExpectationInput",
  componentId: "sc-nlcd1i-4"
})(["border-radius:8px;width:100%;"]);
var NumberOfEditSubmissionTimeInput = styled(NumberInput).withConfig({
  displayName: "base-optionscomponent__NumberOfEditSubmissionTimeInput",
  componentId: "sc-nlcd1i-5"
})(["border-radius:8px;width:100%;"]);
var StyledAutoBanOptionsRow = styled.div.withConfig({
  displayName: "base-optionscomponent__StyledAutoBanOptionsRow",
  componentId: "sc-nlcd1i-6"
})(["display:flex;gap:16px;align-items:center;"]);
var AutoBanOption = styled(InlineOption).withConfig({
  displayName: "base-optionscomponent__AutoBanOption",
  componentId: "sc-nlcd1i-7"
})([".ant-row{align-items:center;.ant-form-item-label{flex:1;width:85%;max-width:85%;text-align:left;}.ant-form-item-control{width:15%;flex-grow:unset;}}"]);
var StyledSecurityOptionSelectBox = styled(Select).withConfig({
  displayName: "base-optionscomponent__StyledSecurityOptionSelectBox",
  componentId: "sc-nlcd1i-8"
})([".ant-select-selector{border-radius:8px !important;}"]);
var StyledAvailableDurationSelectBox = styled(Select).withConfig({
  displayName: "base-optionscomponent__StyledAvailableDurationSelectBox",
  componentId: "sc-nlcd1i-9"
})([".ant-select-selector{border-radius:8px !important;}"]);
var StyledRadioGroup = styled(Radio.Group).withConfig({
  displayName: "base-optionscomponent__StyledRadioGroup",
  componentId: "sc-nlcd1i-10"
})(["display:flex;gap:16px;"]);
export var renderTitleInput = function renderTitleInput(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        children: label.title
      }), /*#__PURE__*/_jsx(StyledRequiredMark, {
        children: "*"
      })]
    }),
    name: "title",
    rules: [{
      required: true,
      message: errorLabel.notEmptyTitle
    }],
    children: /*#__PURE__*/_jsx(TextInput, {
      size: "middle",
      placeholder: label.title
    })
  });
};
export var renderDescriptionInput = function renderDescriptionInput(label) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: label.description,
    name: "description",
    children: /*#__PURE__*/_jsx(TextInput, {
      size: "middle",
      placeholder: label.describeIntroduce
    })
  });
};
export var renderPasswordSwitchOption = function renderPasswordSwitchOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "hasPassword",
    label: label.setPassword,
    initialValue: false,
    isDropDown: true,
    children: /*#__PURE__*/_jsx(Switch, {})
  });
};
export var renderPasswordInput = function renderPasswordInput(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: label.setPassword,
    preserve: true,
    name: "password",
    rules: [{
      validator: function () {
        var _validator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, value) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(!value || value === '')) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", Promise.resolve());

                case 2:
                  if (!(value.length < 8)) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", Promise.reject(errorLabel.minPassword));

                case 4:
                  return _context.abrupt("return", Promise.resolve());

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function validator(_x, _x2) {
          return _validator.apply(this, arguments);
        }

        return validator;
      }()
    }],
    children: /*#__PURE__*/_jsx(PasswordBox, {
      size: "middle",
      placeholder: "".concat(label.inputPassword)
    })
  });
};
export var renderShuffleQuestionOption = function renderShuffleQuestionOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "isShuffleQuestion",
    label: label.mixQuestions,
    initialValue: false,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {})
  });
};
export var renderShuffleAnswerOption = function renderShuffleAnswerOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "isShuffleAnswer",
    label: label.mixAnswers,
    initialValue: false,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {})
  });
};
export var renderShowExplanationSwitchOption = function renderShowExplanationSwitchOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "isShowingExplanationAndCorrectAnswers",
    label: label.showExplanationAfterSubmit,
    initialValue: true,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {
      defaultChecked: true
    })
  });
};
export var renderShowExplanationRadioOptions = function renderShowExplanationRadioOptions(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        children: label.scoreVisibilityType
      }), /*#__PURE__*/_jsx(StyledRequiredMark, {
        children: "*"
      })]
    }),
    name: "scoreVisibilityType",
    initialValue: ScoreVisibilityType.manualPublishScore.value,
    rules: [{
      required: true,
      message: errorLabel.scoreVisibilityTypeIsRequired
    }],
    required: true,
    children: /*#__PURE__*/_jsxs(StyledRadioGroup, {
      children: [/*#__PURE__*/_jsx(DefaultRadio, {
        value: ScoreVisibilityType.manualPublishScore.value,
        children: label.manualPublishScore
      }, ScoreVisibilityType.manualPublishScore.value), /*#__PURE__*/_jsx(DefaultRadio, {
        value: ScoreVisibilityType.immediateViewAfterSubmit.value,
        children: label.immediateViewAfterSubmit
      }, ScoreVisibilityType.immediateViewAfterSubmit.value)]
    })
  });
};
export var renderExpectationItem = function renderExpectationItem(label, errorLabel) {
  var isRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        children: label.expectationAssignment
      }), /*#__PURE__*/_jsx(StyledRequiredMark, {
        children: "*"
      })]
    }),
    name: "expectation",
    initialValue: 50,
    rules: [{
      validator: function () {
        var _validator2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_, value) {
          var regex, isOutOfRange;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  regex = /^[0-9]*$/; // Regular expression to allow only numeric characters

                  if (!(!value || value && value === '')) {
                    _context2.next = 5;
                    break;
                  }

                  if (!isRequired) {
                    _context2.next = 4;
                    break;
                  }

                  return _context2.abrupt("return", Promise.reject(errorLabel.typeExpectationMessage));

                case 4:
                  return _context2.abrupt("return", Promise.resolve());

                case 5:
                  if (!(value && !regex.test(value.toString()))) {
                    _context2.next = 7;
                    break;
                  }

                  return _context2.abrupt("return", Promise.reject(errorLabel.expectationNotAValidNumber));

                case 7:
                  isOutOfRange = value < 1 || value > 100;

                  if (!isOutOfRange) {
                    _context2.next = 10;
                    break;
                  }

                  return _context2.abrupt("return", Promise.reject(errorLabel.expectationIsOutOfRange));

                case 10:
                  return _context2.abrupt("return", Promise.resolve());

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        function validator(_x3, _x4) {
          return _validator2.apply(this, arguments);
        }

        return validator;
      }()
    }, {
      required: isRequired,
      message: errorLabel.missingExpectation
    }],
    children: /*#__PURE__*/_jsx(ExpectationInput, {
      addonAfter: "%"
    })
  });
};
export var renderAllowToEditSubmissionSwitchOption = function renderAllowToEditSubmissionSwitchOption(label, onToggleAllowToEditSubmission) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "isAllowToEditSubmission",
    label: label.allowToEditSubmission,
    initialValue: false,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {
      onChange: onToggleAllowToEditSubmission
    })
  });
};
export var renderHasUnlimitedNumberOfEditSubmissionSwitchOption = function renderHasUnlimitedNumberOfEditSubmissionSwitchOption(label, onToggleSelectUnlimitedEditSubmission) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "isUnlimitedNumberOfEditSubmission",
    label: label.unlimitedNumberOfEditSubmission,
    initialValue: false,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {
      onChange: onToggleSelectUnlimitedEditSubmission
    })
  });
};
export var renderNumberOfEditSubmissionTimeItem = function renderNumberOfEditSubmissionTimeItem(isUnlimitedEditSubmission, label, errorLabel) {
  return isUnlimitedEditSubmission && /*#__PURE__*/_jsx(Form.Item, {
    label: label.numberOfEditSubmissionTime,
    name: "numberOfEditSubmissionTime",
    initialValue: 1,
    rules: [{
      validator: function () {
        var _validator3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_, value) {
          var regex, isOutOfRange;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  regex = /^[0-9]*$/; // Regular expression to allow only numeric characters

                  if (!(!value || value && value === '')) {
                    _context3.next = 3;
                    break;
                  }

                  return _context3.abrupt("return", Promise.reject(errorLabel.typeNumberOfEditSubmissionTime));

                case 3:
                  if (!(value && !regex.test(value.toString()))) {
                    _context3.next = 5;
                    break;
                  }

                  return _context3.abrupt("return", Promise.reject(errorLabel.numberOfSubmissionIsNotAValidNumber));

                case 5:
                  isOutOfRange = value < 1;

                  if (!isOutOfRange) {
                    _context3.next = 8;
                    break;
                  }

                  return _context3.abrupt("return", Promise.reject(errorLabel.numberOfSubmissionIsOutOfRange));

                case 8:
                  return _context3.abrupt("return", Promise.resolve());

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function validator(_x5, _x6) {
          return _validator3.apply(this, arguments);
        }

        return validator;
      }()
    }],
    children: /*#__PURE__*/_jsx(NumberOfEditSubmissionTimeInput, {
      addonAfter: "%"
    })
  });
};
export var renderEnableSecurityOptionSwitchOption = function renderEnableSecurityOptionSwitchOption(label) {
  return /*#__PURE__*/_jsx(InlineOption, {
    name: "hasSecurityOptions",
    label: label.enableSecurityOption,
    initialValue: false,
    isSelectOnly: true,
    children: /*#__PURE__*/_jsx(Switch, {})
  });
};
export var renderSecurityOptionSelection = function renderSecurityOptionSelection(isLoadingGetSecurityOptions, errorLabel, label, securityOptions) {
  if (isLoadingGetSecurityOptions || !securityOptions) {
    return /*#__PURE__*/_jsx(Skeleton.Input, {
      active: true
    });
  }

  var options = securityOptions.map(function (s) {
    return {
      id: s.id.toString(),
      value: s.id.toString(),
      label: s.translation
    };
  });
  return /*#__PURE__*/_jsx(Form.Item, {
    noStyle: true,
    shouldUpdate: function shouldUpdate(prevValues, currentValues) {
      return prevValues.hasSecurityOptions !== currentValues.hasSecurityOptions;
    },
    children: function children(_ref) {
      var getFieldValue = _ref.getFieldValue;
      var hasSecurityOptions = getFieldValue('hasSecurityOptions');
      return hasSecurityOptions && /*#__PURE__*/_jsx(Form.Item, {
        label: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("span", {
            children: label.securityOptionSelection
          }), /*#__PURE__*/_jsx(StyledRequiredMark, {
            children: "*"
          })]
        }),
        required: true,
        name: "securityOptionIds",
        initialValue: securityOptions.map(function (s) {
          return s.id.toString();
        }),
        rules: [{
          validator: function () {
            var _validator4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_, values) {
              var isEmptySelection;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      isEmptySelection = values.length === 0;

                      if (!isEmptySelection) {
                        _context4.next = 3;
                        break;
                      }

                      return _context4.abrupt("return", Promise.reject(errorLabel.mustSelectAtLeastOneOption));

                    case 3:
                      return _context4.abrupt("return", Promise.resolve());

                    case 4:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }));

            function validator(_x7, _x8) {
              return _validator4.apply(this, arguments);
            }

            return validator;
          }()
        }],
        children: /*#__PURE__*/_jsx(StyledSecurityOptionSelectBox, {
          mode: "multiple",
          allowClear: true,
          placeholder: label.securityOptionSelectionPlaceHolder,
          children: options.map(function (option) {
            return /*#__PURE__*/_jsx(Select.Option, {
              value: option.value,
              children: option.label
            }, option.id);
          })
        })
      });
    }
  });
};
export var renderSelectAvailableDurationOptions = function renderSelectAvailableDurationOptions(label) {
  var options = Duration.availableDurations.map(function (duration) {
    var isCustomDuration = duration === Duration.customDuration;

    if (isCustomDuration) {
      return {
        label: label.customDuration,
        value: Duration.customDuration
      };
    }

    return {
      label: "".concat(duration, " ").concat(label.minute),
      value: duration
    };
  });
  return /*#__PURE__*/_jsx(Form.Item, {
    name: "availableDuration",
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        children: label.durationAssignment
      }), /*#__PURE__*/_jsx(StyledRequiredMark, {
        children: "*"
      })]
    }),
    initialValue: Duration.availableDurations[0],
    required: true,
    children: /*#__PURE__*/_jsx(StyledAvailableDurationSelectBox, {
      options: options
    })
  });
};
export var renderDurationInput = function renderDurationInput(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        children: label.durationAssignment
      }), /*#__PURE__*/_jsx(StyledRequiredMark, {
        children: "*"
      })]
    }),
    name: "duration",
    initialValue: 30,
    dependencies: ['rangeDate'],
    required: true,
    rules: [{
      required: true,
      message: errorLabel.durationIsNotValid
    }, function (_ref2) {
      var getFieldValue = _ref2.getFieldValue;
      return {
        validator: function () {
          var _validator5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_, value) {
            var isValidRange, rangeDate, diffInMinutes;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    isValidRange = value && value < 1;

                    if (!isValidRange) {
                      _context5.next = 3;
                      break;
                    }

                    return _context5.abrupt("return", Promise.reject(errorLabel.durationIsNotValid));

                  case 3:
                    rangeDate = getFieldValue('rangeDate');

                    if (!(rangeDate && rangeDate.length === 2 && value)) {
                      _context5.next = 8;
                      break;
                    }

                    diffInMinutes = moment(rangeDate[1]).startOf('minute').diff(moment(rangeDate[0]).startOf('minute'), 'minutes');

                    if (!(value > diffInMinutes)) {
                      _context5.next = 8;
                      break;
                    }

                    return _context5.abrupt("return", Promise.reject(errorLabel.durationMustLessThanDiffRangeOfStartAndEndTime));

                  case 8:
                    return _context5.abrupt("return", Promise.resolve());

                  case 9:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));

          function validator(_x9, _x10) {
            return _validator5.apply(this, arguments);
          }

          return validator;
        }()
      };
    }],
    children: /*#__PURE__*/_jsx(StyledInputNumber, {
      min: 1,
      addonAfter: label.minute
    })
  });
};
export var renderDatePickerByDurationSelection = function renderDatePickerByDurationSelection(label, errorLabel) {
  return /*#__PURE__*/_jsx(Form.Item, {
    noStyle: true,
    shouldUpdate: function shouldUpdate(prevValues, currentValues) {
      return prevValues.availableDuration !== currentValues.availableDuration || prevValues.rangeDate !== currentValues.rangeDate;
    },
    children: function children(_ref3) {
      var getFieldValue = _ref3.getFieldValue,
          setFieldValue = _ref3.setFieldValue;
      var availableDuration = getFieldValue('availableDuration');
      var isNotCustomDuration = availableDuration !== Duration.customDuration;
      var rangeDate = getFieldValue('rangeDate');

      if (availableDuration && isNotCustomDuration && rangeDate && rangeDate.length === 1) {
        var startTime = rangeDate[0];
        var endTime = moment(parseInt(UnixTimestamp.calculateFromDuration(startTime.unix() || Date.now(), parseInt(availableDuration))) * 1000);
        setFieldValue('rangeDate', [startTime, endTime]);
      }

      var customRules = [function (_ref4) {
        var getFieldValue = _ref4.getFieldValue;
        return {
          validator: function () {
            var _validator6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_, value) {
              var availableDuration, isNotCustomDuration, diffInMinutes;
              return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      availableDuration = getFieldValue('availableDuration');
                      isNotCustomDuration = availableDuration !== Duration.customDuration;

                      if (!(value && value.length === 2 && isNotCustomDuration)) {
                        _context6.next = 6;
                        break;
                      }

                      diffInMinutes = moment(value[1]).startOf('minute').diff(moment(value[0]).startOf('minute'), 'minutes');

                      if (!(parseInt(availableDuration) !== diffInMinutes)) {
                        _context6.next = 6;
                        break;
                      }

                      return _context6.abrupt("return", Promise.reject(errorLabel.durationMustLessThanDiffRangeOfStartAndEndTime));

                    case 6:
                      return _context6.abrupt("return", Promise.resolve());

                    case 7:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            }));

            function validator(_x11, _x12) {
              return _validator6.apply(this, arguments);
            }

            return validator;
          }()
        };
      }];
      return renderCombinedDateRangePicker(label, errorLabel, 'rangeDate', ['availableDuration'], customRules);
    }
  });
};
export var renderCombinedDateRangePicker = function renderCombinedDateRangePicker(label, errorLabel) {
  var fieldName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'rangeDate';
  var dependencies = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var customRules = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

  var disabledDate = function disabledDate(current) {
    return current && current < moment().startOf('day');
  };

  var disabledTime = function disabledTime(selectedDate) {
    return {
      disabledHours: !(selectedDate !== null && selectedDate !== void 0 && selectedDate.isAfter(moment.now(), 'days')) && function () {
        return getPastTime().hours;
      },
      disabledMinutes: !(selectedDate !== null && selectedDate !== void 0 && selectedDate.isAfter(moment.now(), 'days')) && function () {
        return getPastTime().minutes;
      }
    };
  };

  var defaultRules = [{
    required: true,
    message: errorLabel.selectDeadlineMessage
  }];
  var allRules = [].concat(defaultRules, _toConsumableArray(customRules));
  return /*#__PURE__*/_jsx(Form.Item, {
    label: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("span", {
        children: [label.startTime, " - ", label.endTime]
      }), /*#__PURE__*/_jsx(StyledRequiredMark, {
        children: "*"
      })]
    }),
    name: fieldName,
    dependencies: dependencies,
    rules: allRules,
    children: /*#__PURE__*/_jsx(DefaultRangePicker, {
      disabledDate: disabledDate,
      disabledTime: disabledTime,
      showTime: {
        format: 'HH:mm'
      },
      format: "DD/MM/YYYY - HH:mm",
      placeholder: [label.startTime, label.endTime]
    })
  });
};
export var renderExaminationDatePicker = function renderExaminationDatePicker(label, errorLabel) {
  var customRules = [function (_ref5) {
    var getFieldValue = _ref5.getFieldValue;
    return {
      validator: function () {
        var _validator7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_, value) {
          var timeAllotted, diffInMinutes;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  timeAllotted = getFieldValue('timeAllotted');

                  if (!(value && value.length === 2 && timeAllotted)) {
                    _context7.next = 5;
                    break;
                  }

                  diffInMinutes = moment(value[1]).startOf('minute').diff(moment(value[0]).startOf('minute'), 'minutes');

                  if (!(timeAllotted >= diffInMinutes)) {
                    _context7.next = 5;
                    break;
                  }

                  return _context7.abrupt("return", Promise.reject(errorLabel.durationMustLessThanDiffRangeOfStartAndEndTime));

                case 5:
                  return _context7.abrupt("return", Promise.resolve());

                case 6:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        function validator(_x13, _x14) {
          return _validator7.apply(this, arguments);
        }

        return validator;
      }()
    };
  }];
  return renderCombinedDateRangePicker(label, errorLabel, 'rangeDate', ['timeAllotted'], customRules);
};
export var renderAutoBanOptions = function renderAutoBanOptions(label, errorLabel) {
  return /*#__PURE__*/_jsxs(StyledAutoBanOptionsRow, {
    children: [/*#__PURE__*/_jsx(Form.Item, {
      shouldUpdate: function shouldUpdate(prevValues, currentValues) {
        return prevValues.hasSecurityOptions !== currentValues.hasSecurityOptions;
      },
      noStyle: true,
      children: function children(_ref6) {
        var getFieldValue = _ref6.getFieldValue;
        var hasSecurityOptions = getFieldValue('hasSecurityOptions');
        return hasSecurityOptions && /*#__PURE__*/_jsx(AutoBanOption, {
          name: "shouldAutoBan",
          label: label.shouldAutoBan,
          initialValue: false,
          children: /*#__PURE__*/_jsx(Switch, {})
        });
      }
    }), /*#__PURE__*/_jsx(Form.Item, {
      noStyle: true,
      shouldUpdate: function shouldUpdate(prevValues, currentValues) {
        return prevValues.shouldAutoBan !== currentValues.shouldAutoBan;
      },
      children: function children(_ref7) {
        var getFieldValue = _ref7.getFieldValue;
        var shouldAutoBan = getFieldValue('shouldAutoBan');
        return shouldAutoBan && /*#__PURE__*/_jsx(Form.Item, {
          name: "maximumFoulsAllowed",
          initialValue: 1,
          required: true,
          rules: [{
            required: true,
            message: errorLabel.maxFoulsAllowedRequiredMessage
          }],
          children: /*#__PURE__*/_jsx(InputNumber, {
            addonAfter: label.maxFoulsAllowedSuffix,
            min: 1,
            placeholder: "1"
          })
        });
      }
    })]
  });
};